import React from 'react';
import { Box } from 'grommet';
import { GridLoader } from 'react-spinners';

const Spinner = () => (
  <Box align="center" justify="center" margin="25px">
    <GridLoader color="#DD1B16" />
  </Box>
);

export { Spinner };
